import { useEffect } from "react";

export default function AppVersion() {
  useEffect(() => {
    window.version = process.env.NEXT_PUBLIC_VERSION;
  }, []);

  return null;
}
